import React from 'react';
import AboutSection from '../components/home/AboutSection';

const About = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h1>A Tech Driven Industrial Raw Material Distribution with an Integrated Supply Chain Platform</h1>
          <p>Leading the way in Polymer Trading, Supply Chain & Logistics Excellence</p>
        </div>
      </section>
      <AboutSection />
    </>
  );
};

export default About;

